/*
 * Generically support OAuth2 redirect from apps a user is connecting
 * to AppBind.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';

class OAuth2Redirect extends Component {

  getRedirectLink(theApp, search, returnedState) {
    const { callPartnerApi } = this.props.auth;

    let payload = {
      operation: "OAuth2Redirect",
      params: {
        app:         theApp,
        search:      search,
        theState:    returnedState,
      }
    };

    return new Promise(function(resolve, reject) {
      callPartnerApi('appbind/generic',
                     'POST',
                     payload)
      .then(response => {
        return response.json();
      })
      .then(data => {
        let theLink = data.link;
        resolve(theLink);
      })
      .catch(err => {
        // console.log('err');
        reject(err);
      });
    });
  }
  
  render() {
    const { isAuthenticated } = this.props.auth;

    if (! isAuthenticated()) { 
      return ( <Redirect to='/home' /> );
    } else {
      const params = new URLSearchParams(this.props.location.search);
      let returnedState = params.get('state');
      let theApp = this.props.match.params.id; // e.g. xero - for example, https://poc.appbind.com/oa2/xero
      let search = this.props.location.search;

      // Check if there is an error (e.g. access denied)
      let error = params.get('error');
      if (error != null) {
        return ( <Redirect to='/home' /> );
      }
  
      Promise.resolve()
      .then(() => {
        return this.getRedirectLink(theApp, search, returnedState);
      })
      .then(redirectLink => {
        if (redirectLink != null) {
          window.location = redirectLink;
        } else {
          return ( <Redirect to='/home' /> );
        }
      })
      .catch(err => {
        return ( <Redirect to='/home' /> );
      });
    }
  
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default OAuth2Redirect;